import Link from "next/link";
import { ArrowRight, CheckCircle2 } from "@/components/icons";
import { CancelRequestButton } from "@/components/deal/cancel-request-button";
import { QuoteSubmittedCard } from "./quote-submitted-card";
import type { ListingRequestSummary } from "./listing-quote-request-state";

export function ExistingListingRequest({
  request,
  canReachDashboard,
  email,
}: {
  request: ListingRequestSummary;
  canReachDashboard: boolean;
  email: string;
}) {
  if (!canReachDashboard) {
    return (
      <QuoteSubmittedCard
        leadId={request.canCancel ? request.leadId : undefined}
        leadNumber={request.leadNumber}
        email={email}
      />
    );
  }
  return (
    <div className="space-y-2">
      <Link
        href={`/dashboard/orders/${request.leadId}`}
        className="group flex items-start gap-3 rounded-lg border border-border bg-muted/30 p-4 transition-colors hover:border-primary/50 hover:bg-muted/50"
      >
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand-tint">
          <CheckCircle2 className="h-5 w-5 text-brand-strong" />
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="text-sm font-semibold text-foreground">
            You already asked about this listing
          </h3>
          <p className="mt-1 text-xs text-muted-foreground">
            Quote {request.leadNumber}. View your request
          </p>
        </div>
        <ArrowRight className="mt-1.5 h-4 w-4 shrink-0 text-muted-foreground transition-colors group-hover:text-foreground" />
      </Link>
      {request.canCancel ? (
        <CancelRequestButton
          leadId={request.leadId}
          leadNumber={request.leadNumber}
          className="w-full"
        />
      ) : null}
    </div>
  );
}
